import { render } from "./vs-result-map.vue?vue&type=template&id=1651bafc&ts=true"
import script from "./vs-result-map.vue?vue&type=script&lang=ts"
export * from "./vs-result-map.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__